

import { Injectable, Inject, OnDestroy } from '@angular/core';
import { Observable, of, combineLatest, forkJoin, Subject, Subscription, OperatorFunction } from 'rxjs';
// tslint:disable-next-line: max-line-length
import {
    getParameterByName,
    DwMdFormActionHandler, DwMdFormActionState, DwMdFormActionResult, DwFormAction, DwSecuritySSOService, DwSecurityRepositoryServiceToken,
    DwSecurityRepositoryService, DwSecurityUserService, DwMdFormContextInfo, DwOrmDataService, DwOrmDataServiceToken, DwMdFormInitActionHandler,
    DwMdFormInitActionState, DwAction, DwActionType, DwFormActionConfigDefaultComponent, DwMetaDataServiceToken,
    DwMetaDataService, DwMetaDataFormApi, DwEventService,
    DwMessagingService, DwFormContextMode, DwContext, DwMetaDataFormStateService, DwInMemoryDataSource, DwOrmData
} from '@devwareapps/devware-cap';
import { Router } from '@angular/router';
import { map, mergeMap, concatAll, switchMap, concatMap } from 'rxjs/operators';
import { WachterUserExt } from '../../../shared/models/wachter-user.model';
import { ProjectKickoffMetaDataItemNames, ProjectsKickoffEntity, ProjectKickoffMetaData, ProjectKickoffActiveUnusedJobNumberQueryEntity } 
    from 'src/app/customizations/project-kickoff/meta-data/projectkickoff-meta-data.service';
import * as moment_ from 'moment';
import { EnhancedUtilsService } from 'src/app/customizations/utils/services/enhanced-utils.service';
import { EthosCustomerEntity } from 'src/app/meta-data/app-meta-data.service';
import { EthosJobNumberEntity, EthosOpportunityEntity, EthosUserEntity, RoEthosUserEntity } from 'src/app/customizations/permits/meta-data/permitsv2-meta-data.service';
import { number } from 'mathjs';
const moment = moment_;
@DwAction({
    isGlobal: false,
    actionType: DwActionType.formAction,
    configComponent: DwFormActionConfigDefaultComponent,
    display: 'Project Kickoff - Add JobNumber',
    keyName: 'projectsKickoffAddJobNumber',
    actionMessage: '',
    parentItemName: ProjectKickoffMetaDataItemNames.ProjectsKickoff,
    defaultButtonConfig: {
        buttonText: 'Add',
        buttonTitle: 'Add JobNumber',
        command: 'addCustomerOpp',
        iconClass: 'fa fa-save',
        buttonClass: 'btn btn-success project-kickoff-btn-shift'
    }
})
@Injectable({
    providedIn: 'root'
})
export class ProjectKickoffAddNewJobNumberActionService
    implements DwMdFormActionHandler, DwMdFormInitActionHandler, OnDestroy {

    formActionState: DwMdFormActionState;
    context : DwContext;
    subscriptions: Subscription[] = [];
    item = ProjectKickoffMetaDataItemNames.ProjectsKickoff;
    addMode: boolean = false;
    editMode: boolean = false;
    args: ProjectKickoffVariableContext;
    private currentDateTime: string = moment().utc().format("MM/DD/YYYY hh:mm A");
    private currentUserId: number = new WachterUserExt(this.dwSecurityUserService.securityContext.ApplicationUser).trustUserId;
    formApi: DwMetaDataFormApi

    constructor(
        private utils : EnhancedUtilsService,
        private dwEventService: DwEventService,
        private dwSecurityUserService: DwSecurityUserService,
        protected msalHandler: DwSecuritySSOService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
        @Inject(DwSecurityRepositoryServiceToken) protected securityRepository: DwSecurityRepositoryService,
        @Inject(DwOrmDataServiceToken) protected dataService: DwOrmDataService,
        private router: Router,
        protected messageService: DwMessagingService
    ) { }

    jobNumberIdRequested: number;
    
    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    initAction(formInitActionState: DwMdFormInitActionState) {
        this.formApi = formInitActionState.formApi;
        this.context = formInitActionState.context;
        this.editMode = this.formApi.getFormConfig().formMode == DwFormContextMode.edit;
        this.addMode = this.formApi.getFormConfig().formMode == DwFormContextMode.add;

        this.jobNumberIdRequested = getParameterByName(this.router, 'Ethos_JobNumberId');
        if (this.jobNumberIdRequested){
            this.formApi.patchVariableContext({ JobNumbers: this.jobNumberIdRequested });
            this.handleAction(null);
        }
        this.formApi.getFormDataChanges(100).subscribe(p => {
            const doc: ProjectsKickoffEntity = p;
            if (this.editMode && (doc.ParentProjectsKickoff ?? []).length == 0){
                this.assemblyGridEntity(doc.JobNumberId).subscribe(r => {
                    const jn = r.JobNumber;
                    const array : ProjectKickoffActiveUnusedJobNumberQueryEntity[] = [ jn ];
                    this.args = this.formApi.getVariableContextValue<ProjectKickoffVariableContext>();
                    this.args.KickoffIds = `${jn.KickoffId}:${(jn as ProjectsKickoffEntity).JobNumberId}`;
                    this.formApi.patchVariableContext(this.args);
                    this.formApi.patchFormData({ ParentProjectsKickoff : array });
                });
            }
        });
    }

    assemblyGridEntity(jn: number) : Observable<AddJnResult> {
        const kickoff: ProjectsKickoffEntity = this.formApi.getFormData();
        const item: ProjectKickoffActiveUnusedJobNumberQueryEntity = {
            ...this.dataService.createDummyEntity(ProjectKickoffMetaDataItemNames.ProjectsKickoff),
            ...{
                JobNumberId: jn, 
                KickoffId: kickoff.KickoffId,
                CreatedByEthos_UserId: this.currentUserId,
                CreatedByDateTime: this.currentDateTime,
                //CreatedByEthos_UserId: this.editing != undefined ? this.editing.CreatedByEthos_UserId : this.currentUserId,
                //CreatedByDateTime : this.editing != undefined ? this.editing.CreatedByDateTime :  this.currentDateTime,
                ModifiedByEthos_UserId: this.currentUserId,
                ModifiedByDateTime: this.currentDateTime,
            }
        };
        const getJn = (data: any[]) => this.dataService.loadEntity(ProjectKickoffMetaDataItemNames.EthosJobNumber, data[0]);
        const getCust = (data : any[]) => 
            data[1]?.CustomerId > 0 ? this.dataService.loadEntity(ProjectKickoffMetaDataItemNames.EthosCustomer, 
                                                                  data[1].CustomerId) : of(null);
        const getPM1 = (data : any[]) => 
            data[1]?.ProjectMgr1UserId > 0 ? this.dataService.loadEntity(ProjectKickoffMetaDataItemNames.RoEthosUser, 
                                                                        data[1].ProjectMgr1UserId) : of(null);
        const getPM2 = (data : any[]) => 
            data[1]?.ProjectMgr2UserId > 0 ? this.dataService.loadEntity(ProjectKickoffMetaDataItemNames.RoEthosUser, 
                                                                        data[1].ProjectMgr2UserId) : of(null);
        const convert = (data : any[]) => {
            const jobn : EthosJobNumberEntity = data[1];
            const cust : EthosCustomerEntity = data[2];
            const pm1 : RoEthosUserEntity = data[3];
            const pm2 : RoEthosUserEntity = data[4];   
            item.EthosCustomerCustomerName = cust.CustomerName;
            item.OpportunityNumber = jobn.OpportunityId;
            item.EthosJobNumberJobNumber = `${jobn.JobNumber} - ${jobn.JobNumberStatus}`;
            item.ProjectName = jobn.JobName;
            item.PM1Name = pm1?.NameFirstLast ?? pm2?.NameFirstLast ?? "";
            item.StartDate = jobn.EstimatedStartDate;
            item.EndDate = jobn.EstimatedEndDate;
            return of({ Customer: cust, JobNumber : item } as AddJnResult);
        };
                                                                        
        return this.utils.chain<AddJnResult>(getJn, getCust, getPM1, getPM2, convert)([jn]);
    }
    save(jn?: number) : Observable<AddJnResult> {
        const addHybridMode : boolean = this.addMode && this.ids.length > 0; 
        /* future support for 'clone' feature const editHybridMode : boolean = !this.addMode && this.ids.length > 0; */

        if (!this.addMode){
            const kickoff: ProjectsKickoffEntity = this.formApi.getFormData();
            //todo add HYBRID mode which is no onger based on ACTUAL mode of form
            // if not editing, saving the entity will automatically refresh the grid
            // TBD this.dataService.saveEntity(item).subscribe(i => { });
            return null;
        }
        else {
            const kickoff: ProjectsKickoffEntity = this.formApi.getFormData();
            // Populate these fields manually when in add mode  (for edit mode, the easiest option is to have a 2 grids - one for add (use Parent Data = true) 
            //   and one for edit (use Parent Data = false). In theory, a save would cause the grid to refresh from the server)
            return this.assemblyGridEntity(jn);
        }
    }

    list : AddJnResult[] = [];
    ids : number[] = [];
    handleAction(formActionState: DwMdFormActionState): Observable<DwMdFormActionResult> {
        this.formActionState = formActionState;
        this.context = formActionState?.context;
        this.args = this.formApi.getVariableContextValue<ProjectKickoffVariableContext>()
        const jn: number[] = (this.args.JobNumbers ?? '').split(',').map(Number);
        this.ids = this.args.KickoffIds?.split(',').map(i => i.split(':')[0]).map(Number) ?? [];

        const list = jn.filter(j => this.list.map(i => (i.JobNumber as ProjectsKickoffEntity).JobNumberId).indexOf(j) == -1);
        const jns = list.map<Observable<AddJnResult>>(i => this.save(i));
        forkJoin(jns).subscribe(results => {
            /* Remove deleted _isDeleted */
            const doc = this.formApi.getFormData() as ProjectsKickoffEntity;
            const newList = this.list.filter(i => {
                const keep = doc.ParentProjectsKickoff.find(j => j.JobNumberId == (i.JobNumber as any).JobNumberId 
                                                                && (i.JobNumber as any)._isDeleted != false);
                return keep != null;                                    
            });
            results.filter(k => newList.findIndex(i => (k.JobNumber as any).JobNumberId == (i.JobNumber as any).JobNumberId) == -1)
                   .forEach(i => newList.push(i));
            this.list = newList;
            this.args.JobNumberCount = this.list.length;
            this.formApi.patchFormData({ ParentProjectsKickoff : this.list.map(i => i.JobNumber) });
        });
        this.blankJobNumbers();
        return null;
    }

    blankJobNumbers(){
        this.args = this.args ?? this.formApi.getVariableContextValue<ProjectKickoffVariableContext>()
        this.args.JobNumbers = null;
        this.updateArgs();
    }
    updateArgs(){
        this.formApi.patchFormData({});
    }

}
export interface ProjectKickoffVariableContext {
    CustomerId?: string;
    KickoffIds?: string;
    JobNumbers?: string;
    JobNumberCount?: number;
}
export interface AddJnResult {
    Customer: EthosCustomerEntity,
    JobNumber: ProjectKickoffActiveUnusedJobNumberQueryEntity
}